import { create } from 'zustand';
import * as Notifications from 'expo-notifications';

interface ParsedURL {
  hostname: string | null;
  path: string | null;
  queryParams: Record<string, string | string[] | undefined> | null;
}

interface NotificationState {
  // Notification state
  pushToken: string | null;
  setPushToken: (token: string | null) => void;
  hasSavedPushToken: boolean;
  setHasSavedPushToken: (hasSavedPushToken: boolean) => void;
  currentNotification: Notifications.Notification | null;
  setCurrentNotification: (
    notification: Notifications.Notification | null,
  ) => void;
  clearCurrentNotification: () => void;

  // Deep link state (mobile)
  currentDeepLink: string | null;
  setCurrentDeepLink: (url: string | null) => void;
  parsedDeepLink: ParsedURL | null;
  setParsedDeepLink: (parsed: ParsedURL | null) => void;
  clearCurrentDeepLink: () => void;

  // Web redirect state (for post-auth redirection)
  pendingWebRedirect: string | null;
  setPendingWebRedirect: (url: string | null) => void;
  clearPendingWebRedirect: () => void;
}

const useNotificationStore = create<NotificationState>((set) => ({
  // Notification state
  pushToken: null,
  setPushToken: (token) => set({ pushToken: token }),
  hasSavedPushToken: false,
  setHasSavedPushToken: (hasSavedPushToken) => set({ hasSavedPushToken }),
  currentNotification: null,
  setCurrentNotification: (notification) =>
    set({ currentNotification: notification }),
  clearCurrentNotification: () => set({ currentNotification: null }),

  // Deep link state (mobile)
  currentDeepLink: null,
  setCurrentDeepLink: (url) => set({ currentDeepLink: url }),
  parsedDeepLink: null,
  setParsedDeepLink: (parsed) => set({ parsedDeepLink: parsed }),
  clearCurrentDeepLink: () =>
    set({
      currentDeepLink: null,
      parsedDeepLink: null,
    }),

  // Web redirect state
  pendingWebRedirect: null,
  setPendingWebRedirect: (url) => set({ pendingWebRedirect: url }),
  clearPendingWebRedirect: () => set({ pendingWebRedirect: null }),
}));

export default useNotificationStore;
